// src/utils/constants.js

export const LOCATIONS = [
  "Civil Lines",
  "Rewa Road",
  "Panna Road",
  "Maihar Road",
  "Birla Nagar",
  "Vijay Nagar",
  "Rampur Baghelan",
  "Nagod Road",
  "Kotwali Area",
  "Tili Road",
  "Madhogarh",
  "Chitrakoot Road",
  "Bahoriband",
  "Railway Colony",
];

export const PROPERTY_TYPES = ["House", "Plot", "Flat", "Shop", "Commercial"];

export const BUDGET_RANGES = [
  { label: "Any Budget", min: 0, max: Infinity },
  { label: "Under ₹10L", min: 0, max: 1000000 },
  { label: "₹10L – ₹25L", min: 1000000, max: 2500000 },
  { label: "₹25L – ₹50L", min: 2500000, max: 5000000 },
  { label: "₹50L – ₹1Cr", min: 5000000, max: 10000000 },
  { label: "Above ₹1Cr", min: 10000000, max: Infinity },
];

export const FURNISHING = ["Unfurnished", "Semi-Furnished", "Fully Furnished"];

export const FACING = ["East", "West", "North", "South", "North-East", "North-West", "South-East", "South-West"];

export const COLORS = {
  primary: "#1a6b3c",
  primaryLight: "#22854b",
  primaryDark: "#0f4d28",
  accent: "#f59e0b",
  accentDark: "#d97706",
  bg: "#f8faf8",
  card: "#ffffff",
  text: "#1a2e1a",
  muted: "#6b7c6b",
  border: "#e2ece2",
  danger: "#c0392b",
  dangerBg: "#fde8e8",
};

export const WHATSAPP_MSG = (title) =>
  `Namaskar! Mujhe aapki property mein interest hai: *${title}* — jo ApnaSatna.com par listed hai. Kya aap details share kar sakte hain?`;
